{
  "familyId": "SWW-BN-VD-DUBBEL",
  "questions": [
    {
      "id": "SWW-BN-VD-DUBBEL-001",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'de ... jongen' (redden → als bijvoeglijk naamwoord)?",
      "context": null,
      "options": ["geredde", "gerede", "geredden", "gereden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Korte Klinker → Dubbel", "content": "Bij een korte klinker verdubbel je de medeklinker: gered (korte e) → geredde (dubbel d).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_short_vowel_double",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord bij korte klinker. Stap 1: Het voltooid deelwoord van 'redden' is 'gered' (ge + red + d, maar dubbele d wordt enkel). Stap 2: 'Gered' heeft een korte 'e'. Stap 3: Bij een korte klinker verdubbel je de medeklinker om de korte klank te behouden: gered + de = geredde (dubbel d). Checkstrategie: hoor je een korte klank? Dan medeklinker verdubbelen. Vergelijk: 'gerede' zou klinken als 'ge-ree-de' (lange e) — dat is fout.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: redden → gered",
          "Luister naar de klinker: 'gered' heeft een korte 'e'",
          "Korte klinker → verdubbel de medeklinker: gered + de = geredde",
          "Check: 'gerede' klinkt als 'ge-ree-de' (lang) — fout"
        ],
        "distractorExplanations": {
          "0": "Correct! Korte klinker → medeklinker verdubbelen: gered + de = geredde (dubbel d).",
          "1": "De medeklinker is hier niet verdubbeld bij een korte klinker. 'Gerede' zou klinken als 'ge-ree-de' (lange e). De korte 'e' in 'gered' vereist een dubbele d: geredde. Misconceptie: de klinkerlengte niet herkennen.",
          "2": "Hier is -en gebruikt in plaats van -e. Bijvoeglijke naamwoorden krijgen -e (niet -en): de geredde jongen (niet geredden). Misconceptie: bijvoeglijk naamwoord verwarren met meervoudsvorm.",
          "3": "Hier zijn werkwoorden verward. 'Gereden' is het voltooid deelwoord van 'rijden' (niet van 'redden'). Redden → gered → geredde."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.bn-short-vowel-not-doubled", "label": "Korte klinker niet herkend, medeklinker niet verdubbeld", "optionIndex": 1 },
          { "id": "sww.bn-uitgang-en-instead-of-e", "label": "Meervoudsuitgang -en gebruikt i.p.v. -e", "optionIndex": 2 },
          { "id": "sww.verb-confusion", "label": "Voltooid deelwoord van ander werkwoord gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-DUBBEL-002",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": null,
      "options": ["De gezette man liep langzaam.", "De gezete man liep langzaam.", "De gezetten man liep langzaam.", "De gezetde man liep langzaam."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Korte Klinker → Dubbel", "content": "Bij een korte klinker verdubbel je de medeklinker: gezet (korte e) → gezette (dubbel t).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_short_vowel_gezet",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord bij korte klinker. Stap 1: Het voltooid deelwoord van 'zetten' is 'gezet'. Stap 2: 'Gezet' heeft een korte 'e'. Stap 3: Bij een korte klinker verdubbel je de medeklinker: gezet + te = gezette (dubbel t). Checkstrategie: hoor je een korte klank? Dan medeklinker verdubbelen.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: zetten → gezet",
          "Luister naar de klinker: 'gezet' heeft een korte 'e'",
          "Korte klinker → verdubbel de medeklinker: gezet + te = gezette",
          "Check: 'gezete' klinkt als 'ge-zee-te' (lang) — fout"
        ],
        "distractorExplanations": {
          "0": "Correct! Korte klinker → medeklinker verdubbelen: gezet + te = gezette (dubbel t).",
          "1": "De medeklinker is hier niet verdubbeld bij een korte klinker. 'Gezete' zou klinken als 'ge-zee-te' (lange e). De korte 'e' in 'gezet' vereist een dubbele t: gezette. Misconceptie: de klinkerlengte niet herkennen.",
          "2": "Hier is -en gebruikt in plaats van -e. Bijvoeglijke naamwoorden krijgen -e (niet -en): de gezette man (niet gezetten). Misconceptie: bijvoeglijk naamwoord verwarren met meervoudsvorm.",
          "3": "Hier is -de toegevoegd aan een stam die op t eindigt. Het voltooid deelwoord is 'gezet' (niet 'gezetd'). Als bijvoeglijk naamwoord: gezet + te = gezette (dubbel t bij korte klinker)."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.bn-short-vowel-not-doubled", "label": "Korte klinker niet herkend, medeklinker niet verdubbeld", "optionIndex": 1 },
          { "id": "sww.bn-uitgang-en-instead-of-e", "label": "Meervoudsuitgang -en gebruikt i.p.v. -e", "optionIndex": 2 },
          { "id": "sww.kofschip-misapplied", "label": "Uitgang -de gebruikt na stam-t (kofschip verkeerd)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-DUBBEL-003",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'het ... kind' (schudden → als bijvoeglijk naamwoord)?",
      "context": null,
      "options": ["geschudde", "geschude", "geschudden", "geschudte"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Korte Klinker → Dubbel", "content": "Bij een korte klinker verdubbel je de medeklinker: geschud (korte u) → geschudde (dubbel d).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_short_vowel_geschud",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord bij korte klinker. Stap 1: Het voltooid deelwoord van 'schudden' is 'geschud'. Stap 2: 'Geschud' heeft een korte 'u'. Stap 3: Bij een korte klinker verdubbel je de medeklinker: geschud + de = geschudde (dubbel d). Checkstrategie: hoor je een korte klank? Dan medeklinker verdubbelen. Vergelijk: 'geschude' zou klinken als 'ge-schuu-de' (lange u) — dat is fout.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: schudden → geschud",
          "Luister naar de klinker: 'geschud' heeft een korte 'u'",
          "Korte klinker → verdubbel de medeklinker: geschud + de = geschudde",
          "Check: 'geschude' klinkt als 'ge-schuu-de' (lang) — fout"
        ],
        "distractorExplanations": {
          "0": "Correct! Korte klinker → medeklinker verdubbelen: geschud + de = geschudde (dubbel d).",
          "1": "De medeklinker is hier niet verdubbeld. 'Geschude' zou klinken als 'ge-schuu-de' (lange u). De korte 'u' in 'geschud' vereist een dubbele d: geschudde. Misconceptie: de klinkerlengte niet herkennen.",
          "2": "Hier is -en gebruikt in plaats van -e. Bijvoeglijke naamwoorden krijgen -e (niet -en): het geschudde kind (niet geschudden). Misconceptie: bijvoeglijk naamwoord verwarren met meervoudsvorm.",
          "3": "Hier is -te gebruikt in plaats van -de. Het voltooid deelwoord 'geschud' eindigt op d (niet in kofschip) → de uitgang is -de: geschudde. Misconceptie: kofschip-uitgang verwarren met bijvoeglijke uitgang."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.bn-short-vowel-not-doubled", "label": "Korte klinker niet herkend", "optionIndex": 1 },
          { "id": "sww.bn-uitgang-en-instead-of-e", "label": "Meervoudsuitgang -en gebruikt i.p.v. -e", "optionIndex": 2 },
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd toegepast (-te i.p.v. -de)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-DUBBEL-004",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist geschreven?",
      "context": null,
      "options": ["De geknotte boom stond in de tuin.", "De geknote boom stond in de tuin.", "De geknotten boom stond in de tuin.", "De geknotde boom stond in de tuin."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Korte Klinker → Dubbel", "content": "Bij een korte klinker verdubbel je de medeklinker: geknot (korte o) → geknotte (dubbel t).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_short_vowel_geknot",
      "variantIndex": 4,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord bij korte klinker. Stap 1: Het voltooid deelwoord van 'knotten' is 'geknot'. Stap 2: 'Geknot' heeft een korte 'o'. Stap 3: Bij een korte klinker verdubbel je de medeklinker: geknot + te = geknotte (dubbel t). Checkstrategie: hoor je een korte klank? Dan medeklinker verdubbelen.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: knotten → geknot",
          "Luister naar de klinker: 'geknot' heeft een korte 'o'",
          "Korte klinker → verdubbel de medeklinker: geknot + te = geknotte",
          "Check: 'geknote' klinkt als 'ge-knoo-te' (lang) — fout"
        ],
        "distractorExplanations": {
          "0": "Correct! Korte klinker → medeklinker verdubbelen: geknot + te = geknotte (dubbel t).",
          "1": "De medeklinker is hier niet verdubbeld. 'Geknote' zou klinken als 'ge-knoo-te' (lange o). De korte 'o' in 'geknot' vereist een dubbele t: geknotte. Misconceptie: de klinkerlengte niet herkennen.",
          "2": "Hier is -en gebruikt in plaats van -e. Bijvoeglijke naamwoorden krijgen -e (niet -en): de geknotte boom (niet geknotten). Misconceptie: bijvoeglijk naamwoord verwarren met meervoudsvorm.",
          "3": "Hier is -de toegevoegd na een t. Maar het voltooid deelwoord is 'geknot' (met t), en de bijvoeglijke uitgang is -te: geknot + te = geknotte. 'Geknotde' bestaat niet."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.bn-short-vowel-not-doubled", "label": "Korte klinker niet herkend", "optionIndex": 1 },
          { "id": "sww.bn-uitgang-en-instead-of-e", "label": "Meervoudsuitgang -en gebruikt i.p.v. -e", "optionIndex": 2 },
          { "id": "sww.kofschip-misapplied", "label": "Uitgang -de gebruikt na stam-t", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-DUBBEL-005",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "fill_in",
      "question": "Vul in: 'de ... olijven' (pitten → als bijvoeglijk naamwoord). Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["gepitte"], "caseSensitive": false, "placeholder": "ge..." },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Korte Klinker → Dubbel", "content": "Bij een korte klinker verdubbel je de medeklinker: gepit (korte i) → gepitte (dubbel t). De korte 'i' moet kort blijven.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_short_vowel_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord bij korte klinker. Stap 1: Het voltooid deelwoord van 'pitten' is 'gepit'. Stap 2: 'Gepit' heeft een korte 'i'. Stap 3: Bij een korte klinker verdubbel je de medeklinker: gepit + te = gepitte (dubbel t). Vergelijk: 'gepite' zou klinken als 'ge-pie-te' (lange i) — dat is fout.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: pitten → gepit",
          "Luister naar de klinker: 'gepit' heeft een korte 'i'",
          "Korte klinker → verdubbel de medeklinker: gepit + te = gepitte"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.bn-short-vowel-not-doubled", "label": "Mogelijke fout: 'gepite' (medeklinker niet verdubbeld)" },
          { "id": "sww.bn-uitgang-en-instead-of-e", "label": "Mogelijke fout: 'gepitten' (meervoudsuitgang)" }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-DUBBEL-006",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "error_spotting",
      "question": "Vind de spellingfouten in de bijvoeglijke naamwoorden (korte klinker, medeklinker verdubbelen).",
      "context": null,
      "correctAnswer": 0,
      "data": {
        "text": "Het gepite kind sliep slecht en het geschude kind sliep onrustig in zijn bed.",
        "errors": [
          { "word": "gepite", "position": 1, "correction": "gepitte", "explanation": "Korte i in 'gepit' vraagt om medeklinker verdubbelen: gepitte (dubbel t). Zonder verdubbeling klinkt het als 'ge-pie-te'." },
          { "word": "geschude", "position": 7, "correction": "geschudde", "explanation": "Korte u in 'geschud' vraagt om medeklinker verdubbelen: geschudde (dubbel d). Zonder verdubbeling klinkt het als 'ge-schuu-de'." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Korte klinker, dubbele medeklinker", "content": "Hoor je een korte klinker in het deelwoord? Dan moet de medeklinker dubbel zijn voor de -e. Anders klinkt het bijvoeglijk naamwoord met een lange klank.", "icon": "lightbulb" } }
      ],
      "conceptId": "adjective_short_vowel_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Twee fouten met korte klinkers. 'Gepite' moet 'gepitte' zijn (korte i, dus dubbele t). 'Geschude' moet 'geschudde' zijn (korte u, dus dubbele d). Spreek elk bijvoeglijk naamwoord hardop uit: hoor je een korte klank, dan moet de medeklinker dubbel.",
        "solutionSteps": [
          "Identificeer het bijvoeglijk naamwoord",
          "Spreek uit: korte of lange klinker?",
          "Korte klinker, medeklinker verdubbelen voor de -e",
          "Beoordeel de geschreven vorm"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.bn-short-vowel-not-doubled", "label": "Korte klinker niet herkend, medeklinker niet verdubbeld" },
          { "id": "sww.vd-klinker-niet-veranderd", "label": "Klinkerlengte in deelwoord niet correct gespeld" }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-DUBBEL-007",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan het juiste bijvoeglijk naamwoord (vorm met -e).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "redden", "right": "geredde" },
          { "left": "zetten", "right": "gezette" },
          { "left": "schudden", "right": "geschudde" },
          { "left": "knotten", "right": "geknotte" },
          { "left": "pitten", "right": "gepitte" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vorm BN bij korte klinker",
            "content": "Voltooid deelwoord (ge...t/d) + -e, en verdubbel de medeklinker omdat de klinker kort is. geredde, gezette, geschudde, geknotte, gepitte.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "adjective_short_vowel_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Voor elk werkwoord: bepaal het voltooid deelwoord, voeg -e toe en verdubbel de medeklinker omdat de klinker kort is. redden → geredde, zetten → gezette, schudden → geschudde, knotten → geknotte, pitten → gepitte.",
        "solutionSteps": [
          "Werkwoord → voltooid deelwoord (ge...t/d)",
          "Korte klinker? → medeklinker verdubbelen",
          "Voeg -e toe als bijvoeglijke uitgang"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.bn-short-vowel-not-doubled", "label": "Medeklinker niet verdubbeld bij korte klinker" }
        ]
      }
    }
  ]
}